import "core-js/modules/es.array.push.js";
import moment from "moment";
export default {
  name: "CalenderHeading",
  props: {
    isLoading: {
      type: Boolean,
      default: false
    },
    filter: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    localYearMonth() {
      return moment(this.filter.yearMonth).format("YYYY年MM月");
    }

  },
  methods: {
    handleMonthPager(mode) {
      if (!this.isLoading) {
        const date = moment(this.filter.yearMonth);

        if (mode === "add") {
          date.add(1, "months");
        }

        if (mode === "sub") {
          date.subtract(1, "months");
        }

        this.$router.push({
          name: this.$route.name,
          query: this.$route.query.temperature ? {
            classroom_id: this.filter.classroomId,
            group_id: this.filter.groupId,
            year_month: date.format("YYYY-MM"),
            temperature: "1"
          } : {
            classroom_id: this.filter.classroomId,
            group_id: this.filter.groupId,
            year_month: date.format("YYYY-MM")
          }
        });
        this.$emit("init");
      }
    }

  }
};